
<style scoped>
	div > p:last-child {
		margin-bottom: 0;
	}

	article {
		margin-top: 1.5em;
		line-height: 1.4rem;
	}

	.main {
		/* max-width: 654px; */
		width: 100%;
		margin-left: auto;
		margin-right: auto;
	}
	.space {
		width: 350px;
		margin-left: 2em;
	}
	.card-secondary {
		width: 350px;
		height: fit-content;
		margin-left: 2.5em;
	}
	.card-secondary h4 {
		margin-bottom: 1em;
	}
	table td {
		font-style: italic;
		vertical-align: top;
	}
	td + td {
		font-size: 14px;;
	}

	.plan-title {
		line-height: 1.3em;
	}

	.plan-card {
		cursor: pointer;
		box-sizing: border-box;
		border-width: 2px;
		width: calc(25% - .75em);
		height: 100%;
		min-height: 142px;
	}
	.dark .plan-card {
		border-color: #333;
	}

	.plan-card {
		min-width: calc(50% - .5rem);
		max-width: calc(50% - .5rem);
		box-sizing: border-box;
		margin-left: 0;
	}

	.plan-card:nth-child(even) {
		margin-left: 1rem;
	}

	.plan-card:nth-child(odd) {
		margin-left: 0;
	}

	.plan-card:nth-child(n+3) {
		margin-top: 1rem;
	}

	.plan-card > header {
		margin-bottom: 0;
	}

	i {
		color: #2E88D6
	}

	ul.plan-cards {
		margin-bottom: .25em;
	}

	.card ul > li + li:before {
		content: '';
		margin-left: 0;
		margin-right: 0;
	}

	.card ul > li:not(:last-child) {
		display: block;
		margin-bottom: 1em;
	}

	.card li > small {
		font-style: italic;
	}

	.badge {
		height: fit-content;
	}

	.jumbo {
		font-size: 1.5em;
	}

	.dark .plan-features li {
		color: #eee;
	}

	.plan-features li .bullet-margin {
		width: 2.5rem;
		text-align: left;
		margin-top: .2rem;
	}
	.plan-features {
		margin-top: 2em;
		margin-bottom: 0;
	}
	.plan-features li {
		color: #555;
		line-height: 1.4rem;
		margin-bottom: 1.25rem;
		margin-left: 1.25em;
		min-width: calc(32%);
		max-width: calc(32%);
	}
	.plan-features li:first-child,
	.plan-features li:nth-child(4) {
		margin-left: 0;
	}
	.plan-features h4 {
		margin-bottom: .25rem;
	}

	h2 + p {
		margin-top: 0;
	}

	.contract {
		letter-spacing: -0.5px;
	}

	/* @media only screen and (max-width : 1140px) {
		article > .row {
			flex-direction: column;
		}
	} */


	@media only screen and (max-width : 1024px) {
		article > .row {
			flex-direction: column;
		}
		.main {
			max-width: unset;
		}
		.content-1100 {
			max-width: 654px;
		}
		.card-secondary {
			width: 100%;
			height: fit-content;
			margin-left: 0;
			margin-top: 2rem;
		}
		aside {
			margin-left: 0;
		}
		.space {
			width: 0;
			margin-left: 0;
		}

		.plan-features.row {
			flex-direction: column;
			flex-wrap: nowrap;
		}
		.plan-features li {
			width: 100%;
			min-width: unset;
			max-width: unset;
			margin-left: 0;
		}
	}

	/* @media only screen and (max-width : 740px) {
		article.row {
			flex-direction: column;
		}
		.card-secondary {
			width: 100%;
			height: fit-content;
		}
		aside:not(.overlay) {
			margin-left: 0;
		} */
	/* } */

</style>

<template>
	<article class="column content content-1100 separated-extra">
		<div class="row">
			<div class="column main flexible separated-extra">
				<div class="rigid">
					<h1>Your license is being discontinued</h1>
					<p>Our records show that you're using a legacy license for our software. In 2025, legacy licenses will be unsupported and legacy license users will not be able to download or generate new license files. If you need to re-install the software and generate a new license file, you will need to purchase a new license.</p>
				</div>
				<div class="rigid">
					<h2>Limited-time offer</h2>
					<p>To help you transition to our modern software, we're offering a limited-time savings promotion from June 21, 2024, to December 31, 2024.</p>
					<div>
						<ul class="rigid row plan-cards flowing packages">
							<li class="plan-card gap">
								<header class="column flexible baseline separated-extra">
									<div class="row separated">
										<i class="fas jumbo flexible fa-tag"></i>
										<span class="badge badge-success rigid">50% Savings</span>
									</div>
									<span class="row baseline flexible">
										<h3 class="plan-title flexible row separated">
											<span class="flexible">1-Year Subscription</span>
										</h3>
										<!-- <span class="badge badge-mono badge-success rigid">Trial</span> -->
									</span>
									<!-- <i class="fas rigid fa-check-circle"></i> -->
								</header>
								<!-- <div class="gray-6">Get 6 extra months</div> -->
							</li>
							<li class="plan-card gap">
								<header class="baseline flexible column separated-extra">
									<div class="row separated">
										<i class="fas jumbo flexible fa-tag"></i>
										<span class="badge badge-success rigid">33% Savings</span>
									</div>
									<span class="row baseline flexible">
										<h3 class="plan-title flexible row separated">
											<span class="flexible">3-Year Subscription</span>
										</h3>
										<!-- <span class="badge badge-mono badge-success rigid">Trial</span> -->
									</span>
									<!-- <i class="fas rigid fa-check-circle"></i> -->
								</header>
								<!-- <div class="gray-6">Get 1 extra year</div> -->
							</li>
							<li class="plan-card gap">
								<header class="baseline flexible column separated-extra">
									<div class="row separated">
										<i class="fas jumbo flexible fa-tag"></i>
										<span class="badge badge-success rigid">25% Savings</span>
									</div>
									<span class="row baseline flexible">
										<h3 class="plan-title flexible row separated">
											<span class="flexible">Perpetual License with 1 Year Maintenance</span>
										</h3>
										<!-- <span class="badge badge-mono badge-success rigid">Trial</span> -->
									</span>
									<!-- <i class="fas rigid fa-check-circle"></i> -->
								</header>
								<!-- <div class="gray-6">Get 6 extra months of maintenance</div> -->
							</li>
							<li class="plan-card gap">
								<header class="baseline flexible column separated-extra">
									<div class="row separated">
										<i class="fas jumbo flexible fa-tag"></i>
										<span class="badge badge-success rigid">25% Savings</span>
									</div>
									<span class="row baseline flexible">
										<h3 class="plan-title flexible row separated">
											<span class="flexible">Perpetual License with 3 Years Maintenance</span>
										</h3>
										<!-- <span class="badge badge-mono badge-success rigid">Trial</span> -->
									</span>
									<!-- <i class="fas rigid fa-check-circle"></i> -->
								</header>
								<!-- <div class="gray-6">Get 9 extra months of maintenance</div> -->
							</li>
						</ul>
						<!-- <small class="gray-6">To purchase a current license, please contact your Tektronix contact or use <a target="_blank" href="https://www.tek.com">tek.com</a></small> -->
					</div>
					<p>To use this promo, please take a screenshot of this current page (as a proof of your qualification) and send it to your Tektronix Sales contact or enter <em>'I am a legacy user and my tekcloud.com email id is abc@xyz.com'</em>&nbsp; in the comments field while filling out your quote request on Tek.com</p>
				</div>

			</div>
			<div class="column card card-secondary rigid">
				<!-- <h2 class="no-margin-top">Discontinued Licenses</h2> -->
				<h4 class="no-margin-top uppercase">Discontinued Licenses</h4>
				<ul>
					<li>
						<div>Multi-Scope Analysis</div>
						<small class="gray-6">TEKSCOPE-MULTI-1YR, TEKSCOPE-MULTI-PER</small>
					</li>
					<li>
						<div>Low Speed Protocol Decode</div>
						<small class="gray-6 contract">TEKSCOPE-DECODE-1YR, TEKSCOPE-DECODE-PER</small>
					</li>
					<li>
						<div>Jitter Measurements and Analysis</div>
						<small class="gray-6">TEKSCOPE-DJA-1YR, TEKSCOPE-DJA-PER</small>
					</li>
					<li>
						<div>Power Electronics Analysis</div>
						<small class="gray-6">TEKSCOPE-ELC-1YR, TEKSCOPE-ELC-PER</small>
					</li>
					<li>
						<div>Power Integrity Analysis</div>
						<small class="gray-6">TEKSCOPE-INT-1YR, TEKSCOPE-INT-PER</small>
					</li>
					<li>
						<div>Low Speed Protocol Decode</div>
						<small class="gray-6">TEKSCOPE-SV-1YR, TEKSCOPE-SV-PER</small>
					</li>
					<li>
						<div>Remote Analysis for Bench Oscilloscopes</div>

						<small class="gray-6">TEKSCOPE-ENTRY-1YR, TEKSCOPE-ENTRY-PER</small>
					</li>
				</ul>
			</div>
		</div>
		<div class="column rigid">
			<div class="row">
				<div class="column gap">
					<h2>Upgrade benefits</h2>
					<p>Upgrading to the latest TekScope version provides valuable new features and improvements. By staying on an active maintenance plan, you'll continue to receive access to the latest version of our software with bug fixes, security updates, and new features. To see the value we've delivered in the past two years, here's a quick summary of enhancements.</p>
				</div>
				<div class="rigid space"></div>
			</div>
			<ul data-v-479f3822="" class="plan-features row separated-extra flowing">
					 <!-- <div class="column flexible"> -->
						<li class="bullet">
							<div class="bullet-margin">
								<i class="fas fa-check jumbo"></i>
							</div>
							<div class="bullet-content column">
								<h4>New Measurements and Data Analysis</h4>
								SpectrumView IQ data import, de-skew max limit increased, data logging with timer event control save on trigger, live 8-bit digital data import, Spectrogram, Multi-Source cursors, Spectrum View with Zoom support, improved UX for remote channel offsets, Waveform Histogram supports count, hits in box, peak hits, max/min, peak to peak, mean, median, standard deviation 1-2-3 sigma.
							</div>
						</li>
						<li class="bullet">
							<div class="bullet-margin">
								<i class="fas fa-check jumbo"></i>
							</div>
							<div class="bullet-content column">
								<h4>File and Session Management Enhancements</h4>
								Improved setup/session/waveform recall, support for .jsf, recalling digital source session files, greatly improved support for TekDrie including copy/paste files/folders from local drive to TekDrive which is great for getting files/folders from scopes to PC, added measurement annotations, etc.
							</div>
						</li>
						<li class="bullet">
							<div class="bullet-margin">
								<i class="fas fa-check jumbo"></i>
							</div>
							<div class="bullet-content column">
								<h4>User Experience Enhancements</h4>
								1 click export all TekScope logs for faster product support, improved long press touch gesture, app launch progress bar, removed the auto set page in user preferences, auto-execute VXI-11 server improves connectivity with NI-VISA, recent files quick menu.
							</div>
						</li>
						<li class="bullet">
							<div class="bullet-margin">
								<i class="fas fa-check jumbo"></i>
							</div>
							<div class="bullet-content column">
								<h4>Improved Connectivity and Control</h4>
								Updated Firewall support, better VNC wrapper for remote scopes
							</div>
						</li>
						<li class="bullet">
							<div class="bullet-margin">
								<i class="fas fa-check jumbo"></i>
							</div>
							<div class="bullet-content column">
								<h4>More scopes supported</h4>
								TDS2000C, MSO 5000, DPO 5000, DPO7000, 5 Series MSO B, MSO 3000, 2 Series MSO, MDO 3000, 3 Series MDO
							</div>
						</li>
						<li class="bullet">
							<div class="bullet-margin">
								<i class="fas fa-check jumbo"></i>
							</div>
							<div class="bullet-content column">
								<h4>And of course, bug fixes!</h4>
							</div>
						</li>
					<!-- </div> -->
				</ul>
			</div>
			<div class="row">
				<div class="column gap">
					<h2>Upcoming features: High Speed Interface <span class="badge badge-success">New</span></h2>
					<p>Next geneation High speed interface (HSI) framework that will allow userse to move data from scopes to users’ PC at speeds 2.5x or higher compared to current VXI-11 ethernet (VISA) connections. This feature will be available on instruments: MSO 4/5/6 (including B and LP models) in single connection to the scope and in TekScope's multi-scope connectivity feature.</p>
				</div>
				<div class="rigid space"></div>
			</div>
		 <!-- </div> -->
	</article>
</template>

<script>
export default {
	name: 'Legacy',
	computed:{
	}
};

</script>



// WEBPACK FOOTER //
// ./src/views/LegacyTekScope.vue